module.exports = __webpack_public_path__ + "static/latest-news-73c0377ed7927b1bb6506d1581f6f0b7.gif";